<template>
  <modal v-if="isOpen" class-name="car-details-modal" @close="$emit('close')">
    <template #body>
      <ul>
        <li>
          <div class="car-details-modal__title-wrap">
            <img src="../../assets/images/details-icons/car-heart.png" alt="" />
            <h3>Fahrzeugdetails</h3>
          </div>
          <ul class="car-details-modal__main-details">
            <li>
              <h6>Fahrzeugart</h6>
              <p>{{ agetype.name }}</p>
            </li>
            <li>
              <h6>Erstzulassung</h6>
              <p>{{ carDetails.registration_date }}</p>
            </li>
            <li>
              <h6>Kilometerstand</h6>
              <p>{{ carDetails.mileage_km }}</p>
            </li>
            <li>
              <h6>Leistung</h6>
              <p>{{ carDetails.power }}</p>
            </li>
            <li>
              <h6>Kraftstoffart</h6>
              <p>{{ carDetails.fueltype_name }}</p>
            </li>
            <li>
              <h6>Getriebe</h6>
              <p>{{ carDetails.geartype_name }}</p>
            </li>
            <li>
              <h6>Farbe</h6>
              <p>{{ car.color.exterior.name }}</p>
            </li>
            <li>
              <h6>Herstellerfarbbezeichnung</h6>
              <p>{{ car.color.exterior.origin }}</p>
            </li>
            <li>
              <h6>Farbe der Innenausstattung</h6>
              <p>{{ car.color.interior.name }}</p>
            </li>
            <li>
              <h6>Innenausstattung</h6>
              <p>{{ car.interior_type.name }}</p>
            </li>
            <li>
              <h6>Hubraum</h6>
              <p>{{ car.ccm }}</p>
            </li>
            <li>
              <h6>Sitzplätze</h6>
              <p>{{ car.seats }}</p>
            </li>
            <li>
              <h6>Anzahl der Fahrzeughalter</h6>
              <p>{{ car.ancestors }}</p>
            </li>
            <li>
              <h6>Türen</h6>
              <p>{{ car.doors && car.doors.join('/') }}</p>
            </li>
            <li>
              <h6>TÜV/HU</h6>
              <p>{{ car.mot }}</p>
            </li>
          </ul>
          <ul class="car-details-modal__additional-details">
            <li v-for="item in extrasByCategories.Fahrzeugdetails" :key="item">{{ item }}</li>
          </ul>
        </li>
        <li>
          <div class="car-details-modal__title-wrap">
            <img src="../../assets/images/details-icons/wheel.png" alt="" />
            <h3>Ausstattung</h3>
          </div>
          <ul class="car-details-modal__additional-details">
            <li v-for="item in extrasByCategories.extrasDefault" :key="item">{{ item }}</li>
          </ul>
        </li>
        <li>
          <div class="car-details-modal__title-wrap">
            <img src="../../assets/images/details-icons/airbag.png" alt="" />
            <h3>Sicherheit</h3>
          </div>
          <ul class="car-details-modal__additional-details">
            <li v-for="item in extrasByCategories.Sicherheit" :key="item">{{ item }}</li>
          </ul>
        </li>
        <li>
          <div class="car-details-modal__title-wrap">
            <img src="../../assets/images/details-icons/radio.png" alt="" />
            <h3>Radio, Audio, Kommunikation</h3>
          </div>
          <ul class="car-details-modal__additional-details">
            <li v-for="item in extrasByCategories['Radio, Audio, Kommunikation']" :key="item">
              {{ item }}
            </li>
          </ul>
        </li>
        <li>
          <div class="car-details-modal__title-wrap">
            <img src="../../assets/images/details-icons/leaf.png" alt="" />
            <h3>Verbrauch und Umwelt</h3>
          </div>
          <ul class="car-details-modal__consumption">
            <li>
              <h5>Kraftstoffverbrauch*:</h5>
              <!-- <ul v-if="!car.emission.allowed_formats.wltp">
                <li><b>innerorts:</b> {{ car.emission.consumption.intown ? `${car.emission.consumption.intown} l/100km` : 'entfällt' }}</li>
                <li><b>ausserorts:</b> {{ car.emission.consumption.outtown ? `${car.emission.consumption.outtown} l/100km` : 'entfällt' }}</li>
                <li><b>kombiniert:</b> {{ car.emission.consumption.average ? `${car.emission.consumption.average} l/100km` : 'entfällt' }}</li>
                <li><b>Stromverbrauch:</b> {{ car.emission.consumption.electro ? `${car.emission.consumption.electro} kWh/100km` : 'entfällt' }}</li>
              </ul> -->
              <ul>
                <li v-if="wltp.wltp_consumption_fuel_weighted_combined" style="margin-bottom:20px;">
                  <b>Kraftstoffverbrauch (WLTP)</b>
                  {{ wltp.wltp_consumption_fuel_weighted_combined }} {{ unit }} (komb., gewichtet)*
                </li>

                <li v-if="wltp.wltp_consumption_combined">
                  <b>Kraftstoffverbrauch (WLTP)</b>
                  {{ wltp.wltp_consumption_combined }} {{ unit }} (komb.)*
                </li>
                <li v-if="wltp.wltp_consumption_slow">
                  <b>Innenstadt</b>
                  {{ wltp.wltp_consumption_slow }} {{ unit }} (komb.)*
                </li>
                <li v-if="wltp.wltp_consumption_medium">
                  <b>Stadtrand</b>
                  {{ wltp.wltp_consumption_medium }} {{ unit }} (komb.)*
                </li>
                <li v-if="wltp.wltp_consumption_fast">
                  <b>Landstraße</b>
                  {{ wltp.wltp_consumption_fast }} {{ unit }} (komb.)*
                </li>
                <li v-if="wltp.wltp_consumption_very_fast" style="margin-bottom:20px;">
                  <b>Autobahn</b>
                  {{ wltp.wltp_consumption_very_fast }} {{ unit }} (komb.)*
                </li>

                <li v-if="wltp.wltp_consumption_electricity_weighted_combined" style="margin-bottom:20px;">
                  <b>Stromverbrauch (WLTP)</b>
                  {{ wltp.wltp_consumption_electricity_weighted_combined }} kWh/100km (komb., gewichtet)*
                </li>

                <li v-if="wltp.wltp_consumption_electricity_combined">
                  <b>Stromverbrauch (WLTP)</b>
                  {{ wltp.wltp_consumption_electricity_combined }} kWh/100km (komb.)*
                </li>
                <li v-if="wltp.wltp_consumption_electricity_slow">
                  <b>Innenstadt</b>
                  {{ wltp.wltp_consumption_electricity_slow }} kWh/100km (komb.)*
                </li>
                <li v-if="wltp.wltp_consumption_electricity_medium">
                  <b>Stadtrand</b>
                  {{ wltp.wltp_consumption_electricity_medium }} kWh/100km (komb.)*
                </li>
                <li v-if="wltp.wltp_consumption_electricity_fast">
                  <b>Landstraße</b>
                  {{ wltp.wltp_consumption_electricity_fast }} kWh/100km (komb.)*
                </li>
                <li v-if="wltp.wltp_consumption_electricity_very_fast" style="margin-bottom:20px;">
                  <b>Autobahn</b>
                  {{ wltp.wltp_consumption_electricity_very_fast }} kWh/100km (komb.)*
                </li>
                
                <li v-if="wltp.wltp_consumption_discharged_battery_combined" style="margin-bottom:20px;">
                  <b>Verbrauch bei entladener Batterie (WLTP)</b>
                  {{ wltp.wltp_consumption_discharged_battery_combined }} l/100km (komb.)*
                </li>
                
                <li v-if="wltp.wltp_electric_motor_range">
                  <b>Gesamtreichweite innerorts (WLTP)</b>
                  {{ wltp.wltp_electric_motor_range }} km
                </li>
                <li v-if="wltp.wltp_electric_motor_range_urban_areas">
                  <b>Elektrische Reichweite innerorts (WLTP)</b>
                  {{ wltp.wltp_electric_motor_range_urban_areas }} km
                </li>
                <li v-if="wltp.wltp_total_range">
                  <b>Gesamtreichweite (WLTP)</b>
                  {{ wltp.wltp_total_range }} km
                </li>
                <li v-if="wltp.wltp_total_range_urban_areas" style="margin-bottom:20px;">
                  <b>Elektrische Reichweite (WLTP)</b>
                  {{ wltp.wltp_total_range_urban_areas }} km
                </li>
                
                <li v-if="wltp.battery_state_of_health">
                  <b>Batteriezustand</b>
                  {{wltp.battery_state_of_health}} kWh/100km (komb.)*
                </li>
              </ul>
            </li>
            <li v-if="(wltp.wltp_emission_weighted_combined || wltp.wltp_emission_weighted_combined === 0 || wltp.wltp_emission_combined || wltp.wltp_emission_combined === 0)">
              <h5>Emissionswerte*:</h5>
              <ul>
                <!-- <li v-if="!car.emission.allowed_formats.wltp"><b>CO2 Emission:</b> {{ car.emission.co2_emission ? `${ car.emission.co2_emission}g CO₂/km (komb.)*` : '0g CO₂/km (komb.)*' }}</li> -->
                <li v-if="(wltp.wltp_emission_weighted_combined || wltp.wltp_emission_weighted_combined === 0)">
                  <b>CO<sub>2</sub>-Emissionen (WLTP)</b>
									{{ wltp.wltp_emission_weighted_combined }} g CO₂/km (komb., gewichtet)*
                </li>
                <li v-if="(wltp.wltp_emission_combined || wltp.wltp_emission_combined === 0)">
                  <b>CO<sub>2</sub>-Emissionen (WLTP)</b>
									{{ wltp.wltp_emission_combined }} g CO₂/km (komb.)*
                </li>
                <!-- <li><b>Energieeffizienzklasse:</b> {{ efficiencyClassLabelMap[car.co2_efficiency_class] || '' }}</li> -->
              </ul>
            </li>
            <li v-if="car.emission.emission_sticker || car.co2_emission_class">
              <h5>Umwelt:</h5>
              <ul>
                <li v-if="car.emission.emission_sticker"><b>Umweltplakette:</b> {{ car.emission.emission_sticker }}</li>
                <li v-if="car.co2_emission_class"><b>Schadstoffklasse:</b> {{ car.co2_emission_class.name }}</li>
              </ul>
            </li>
            <li v-if="efficiencyClass">
              <EnergyEfficience :efficiency-class="efficiencyClass" :battery-efficiency-class="batteryEfficiencyClass" :plugin_hybrid_extended="car.plugin_hybrid_extended" />
            </li>
          </ul>
          <p
            class="car-emission-note"
          >
            * Weitere Informationen zum offiziellen Kraftstoffverbrauch und den
            offiziellen spezifischen CO2-Emissionen neuer Personenkraftwagen können
            dem »Leitfaden über den Kraftstoffverbrauch, die CO2-Emissionen und den
            Stromverbrauch neuer Personenkraftwagen «entnommen werden, der an allen
            Verkaufsstellen und bei der Deutschen Automobil Treuhand GmbH unter
            <a href="https://www.dat.de" target="_blank">www.dat.de</a> unentgeltlich
            erhältlich ist.
          </p>
        </li>
      </ul>
    </template>
  </modal>
</template>

<script>
import Modal from '../common/Modal';
import EnergyEfficience from '../EnergyEfficience';

export default {
  components: {
    Modal,
    EnergyEfficience,
  },
  props: ['isOpen', 'car', 'carDetails'],
  data() {
    return {
      message: '',
      efficiencyClassLabelMap: {
        ATriplePlus: 'A+++',
        ADoublePlus: 'A++',
        APlus: 'A+',
        A: 'A',
        B: 'B',
        C: 'C',
        D: 'D',
        E: 'E',
        F: 'F',
        G: 'G',
     },
    };
  },
  computed: {
    extrasCategoriesByIDs() {
      return {
        'Radio, Audio, Kommunikation': [8, 16, 19, 25, 51, 53, 54, 55, 79, 80, 82, 83, 117, 126, 129, 130, 131, 132],
        Sicherheit: [9, 12, 22, 43, 52, 60, 61, 64, 66, 67, 68, 69, 71, 107, 108, 110, 111, 112, 116, 124, 125, 127, 133, 138, 141],
        Fahrzeugdetails: [15, 23, 28, 31, 34, 35, 36, 38, 40, 42, 45, 48, 65, 84, 85, 86, 87, 88, 91, 92, 93, 94, 140],
        default: 'Ausstattung',
      };
    },
    extrasByCategories() {
      return this.getExtrasByCategories(this.car.extras);
    },
    isWltp() {
      return this.car.emission.allowed_formats.wltp;
    },
    wltp() {
        return this.car.emission.wltp;
    },
    efficiencyClass() {
      return this.car.plugin_hybrid_extended ? this.wltp.wltp_co2_emission_class_weighted : this.wltp.wltp_co2_emission_class;
    },
    batteryEfficiencyClass() {
      return this.wltp.wltp_emission_class_weighted_combined_empty_battery;
    },
    unit() {
      return this.car.emission.consumption_unit;
    },
    agetype() {
      return this.car.agetype;
    }
  },
  methods: {
    sendMessage() {
      console.log('send message', this.message);
      this.$emit('close');
    },
    getCategoryName(optionID) {
      let title = 'extrasDefault';

      // forOwn(this.extrasCategoriesByIDs, (catIDs, catName) => {
      //   if (~catIDs.indexOf(optionID)) { title = catName; }
      // });

      // eslint-disable-next-line no-restricted-syntax
      for (let [catName, catIDs] of Object.entries(this.extrasCategoriesByIDs)) {
        if (~catIDs.indexOf(optionID)) {
          title = catName;
        }
      }

      return title;
    },
    getExtrasByCategories(src) {
      return src.reduce((res, item) => {
      const catName = this.getCategoryName(item.id);

      if (!res[catName]) { Object.assign(res, { [catName] : [] }); }

      res[catName].push(item.name);
      return res;
    }, {})},
  },
};
</script>

<style lang="scss" scoped>
.car-details-modal {
  &__title-wrap {
    display: flex;
    align-items: flex-start;
    padding-bottom: 0.625rem;
    border-bottom: 0.0625rem solid $border-gray;
  }
  h3 {
    padding-left: 0.625rem;
    margin-bottom: 0.3125rem;
    font-size: 0.9375rem;
    font-weight: 700;
    @include breakpoint(tablet) {
      font-size: 25px;
      margin-bottom: 20px;
      padding-left: 30px;
    }
  }
  &__main-details {
    li {
      padding: 0.625rem 0;
      border-bottom: 0.0625rem solid $border-gray;
      &:last-child {
        border-bottom: none;
      }
      h6 {
        padding-left: 0.625rem;
        font-size: 0.875rem;
      }
      p {
        padding-left: 0.625rem;
        font-size: 0.875rem;
      }
    }
  }
  &__additional-details {
    margin: 1.25rem 0 1.875rem;
    li {
      position: relative;
      padding: 0.3125rem 0 0.3125rem 1.25rem;
      &:before {
        @include icon('\f105', #d9d9d9, 1.125rem);
        left: 0;
        top: 50%;
        transform: translateY(-75%);
      }
    }
  }
  &__consumption {
    margin-bottom: 1.25rem;
    padding-right: 1.25rem;
    h5 {
      padding: 1.25rem 0 0.9375rem;
      font-size: 1rem;
      font-weight: 700;
    }
    img {
      width: 100%;
      max-width: 16.25rem;
    }
    ul {
      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 0.9375rem;
      }
    }
    p {
      margin-bottom: 1.25rem;
      line-height: 1.375em;
    }
  }

  .car-emission-note {
    font-size: 10px;
    line-height: 14px;
    color: #131313;
    margin-bottom: 20px;
  }
}
</style>
